import React, {Component} from 'react';
// import TextField from 'material-ui/TextField';
import {InputText} from '../../blocks/inputs/InputText';
import { inject, observer } from 'mobx-react';
import Player from '@vimeo/player';

@inject('topicsStore')
@inject('userStore')
@observer
class Video extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tutorial_videos_attributes: [],
      showInputs: false,
      deletedVideos: []
    };
  }

  componentDidMount() {
    const {topicsStore} = this.props;
    this.setState({
      tutorial_videos_attributes: topicsStore.topic.tutorial_videos_attributes
    });
  }
  
  componentDidUpdate(prevProps, prevState) {
    const {topicsStore} = this.props;
    if(!prevState.tutorial_videos_attributes[0] &&
      prevState.tutorial_videos_attributes.length < topicsStore.topic.tutorial_videos_attributes.length
    ) {
      this.setState({
        tutorial_videos_attributes: topicsStore.topic.tutorial_videos_attributes
      });
    }
  }

  handleChange = index => e => {
    const {tutorial_videos_attributes} = this.state;
    const new_tutorial_videos_attributes = [...tutorial_videos_attributes];
    let new_tutorial_videos_attribute = {...new_tutorial_videos_attributes[index]};
    new_tutorial_videos_attribute = {
      ...new_tutorial_videos_attribute,
      [e.target.name]: e.target.value
    };
    new_tutorial_videos_attributes[index] = {...new_tutorial_videos_attribute};
    this.setState({tutorial_videos_attributes: new_tutorial_videos_attributes});
  }

  updateUrl = () => {
    const {tutorial_videos_attributes} = this.state;
    this.setState({showInputs: false});
    this.props.topicsStore.handleChange({tutorial_videos_attributes});
  }

  deleteVideo = index => () => {
    const {tutorial_videos_attributes, deletedVideos} = this.state;
    const new_tutorial_videos_attributes = [...tutorial_videos_attributes];
    let deletedVideo = new_tutorial_videos_attributes.splice(index, 1)[0];
    deletedVideo = {...deletedVideo, _destroy: true};
    deletedVideos.push(deletedVideo);
    this.setState({tutorial_videos_attributes: new_tutorial_videos_attributes, deletedVideos});
    this.props.topicsStore.handleChange({tutorial_videos_attributes: [...new_tutorial_videos_attributes, ...deletedVideos]});
  }

  showInputsVideo = () => {
    this.setState({showInputs: true});
  }

  handleIframeLoad = () => {
    let iframe = document.querySelector('iframe');
    this.player = new Player(iframe);
    window.player = this.player;
  };

  addVideo = () => {
    const {tutorial_videos_attributes} = this.state;
    const new_tutorial_videos_attributes = [...tutorial_videos_attributes]
    new_tutorial_videos_attributes.push({
        title: '',
        description: '',
        video_url: '',
        friendly_id_url: ''
    });
    this.setState({tutorial_videos_attributes: new_tutorial_videos_attributes});
  }

  renderEmbeded = url => {
    return (
      <div
        dangerouslySetInnerHTML={{__html: url}}
        className='topic-video'
      />
    );
  }

  renderNoVideo = () => (
    this.props.userStore.isAdmin() ?
      <div className="row justify-content-start video-save video-fields col-12">
        <button onClick={this.addVideo}>
          + Add one more video
        </button>
      </div> : null
  )

  render() {
    const {userStore, topic} = this.props;
    const {tutorial_videos_attributes, showInputs} = this.state;

    return (
      <div className="tab-container" style={userStore.isAdmin() ? {} : {marginTop: '42px'}}>
        <div className="row justify-content-between">
          { userStore.isAdmin() && (!topic.tutorial_videos_attributes[0] || showInputs) ? (
              <div className="col-12 container-body">
                {tutorial_videos_attributes.map((video, index) => (
                  <div className="video-fields" key={index}>
                    <div className="row justify-content-start video-fields col-12">
                      <h3 className='container-header'>{video.title ? video.title : 'Add Video Tutorial'}</h3>
                      <button className='delete-btn' onClick={this.deleteVideo(index)}>
                        Delete
                      </button>
                    </div>
                    <div className="col-sm-12">
                      <InputText
                        name='title'
                        label='Video title'
                        placeholder='Video title'
                        fullWidth={true}
                        onChange={this.handleChange(index)}
                        value={video.title}
                      />
                    </div>
                    <div className="col-sm-12">
                      <InputText
                        name='description'
                        label='Video description'
                        placeholder='Video description'
                        fullWidth={true}
                        onChange={this.handleChange(index)}
                        value={video.description}
                      />
                    </div>
                    <div className="col-sm-12">
                      <InputText
                        name='video_url'
                        label='Video URL'
                        placeholder='Video URL'
                        fullWidth={true}
                        onChange={this.handleChange(index)}
                        value={video.video_url}
                      />
                    </div>
                    <div className="col-sm-12">
                      <InputText
                        name='friendly_id_url'
                        label='Friendly URL (OPTIONAL)'
                        placeholder='Friendly URL (OPTIONAL)'
                        fullWidth={true}
                        onChange={this.handleChange(index)}
                        value={video.friendly_id_url}
                      />
                    </div>
                  </div>
                ))}
                <div className="row justify-content-start video-save video-fields col-12">
                  <button onClick={this.addVideo}>
                    + Add one more video
                  </button>
                </div>
                <div className="row justify-content-center video-save">
                  <button onClick={this.updateUrl} className="btn-new-main">Update</button>
                </div>
              </div>
            ) : (
              tutorial_videos_attributes && tutorial_videos_attributes.length > 0 ? tutorial_videos_attributes.map((video, index) => (
                <div className="container-body" style={userStore.isAdmin() ? {} : {marginTop: '42px'}} key={index}>
                  <div className="row justify-content-start">
                    <h3 className='container-header video-header'>{video.title}</h3>
                  </div>
                  {/* <p>{video.description}</p> */}
                  {this.renderEmbeded(video.video_url)}
                    {/* <iframe
                      width="100%"
                      height="100%"
                      src={video.video_url || ''}
                      frameBorder="0"
                      allowFullScreen
                      onLoad={this.handleIframeLoad}
                    ></iframe> */}
                  {/* <div style={{marginBottom: '50%'}}> */}
                    {/* <div className="frame-wrapper">
                    </div> */}
                  {/* </div> */}
                  { userStore.isAdmin() &&
                    <div className="row justify-content-center edit-controlls video-save">
                      <button className='delete' onClick={this.deleteVideo(index)}>delete</button>
                      <button className='create' onClick={this.showInputsVideo}>edit video</button>
                    </div>
                  }
                </div>
              )) : this.renderNoVideo()
            )
          }
        </div>
      </div>
    );
  }
}

export default Video;


// WEBPACK FOOTER //
// ./src/modules/topic/components/Video.js